var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"float-left",attrs:{"text":"","icon":"","x-large":"","color":"secondary darken-1","title":"Back"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('v-icon',[_vm._v("mdi-chevron-left")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }